module.exports = __webpack_public_path__ + "media/images/icons/search-963f3c0ba5b6e770ab2c62f7bbc3e0ad.svg";